// extracted by mini-css-extract-plugin
export default {"cardsContainer":"ManualDeduction_cardsContainer__T+s4W"};